import { Button, Tooltip } from 'antd';
import React, { useState } from 'react';
import EditStructuredPropertyModal from './EditStructuredPropertyModal';
import { StructuredPropertyEntity, EntityType } from '../../../../../../types.generated';
import { ReactComponent as EditIconOutlined } from '../../../../../../images/icon-edit-outline.svg';
import { useTranslation } from '../../../../../../i18n/useTranslation';

interface Props {
    readOnly?: boolean;
    entityType: EntityType;
    structuredProperty?: StructuredPropertyEntity;
    associatedUrn?: string;
    values?: (string | number | null)[];
    refetch?: () => void;
}

export function EditColumn({ readOnly, structuredProperty, associatedUrn, values, refetch, entityType }: Props) {
    const { t } = useTranslation();
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);

    if (!structuredProperty || structuredProperty?.definition.immutable) {
        return null;
    }

    const isSupported = structuredProperty?.definition.entityTypes?.some((entity) => entity?.info.type === entityType);
    const isDisabledOrUnsupported = !structuredProperty?.definition.isActive || !isSupported;

    const getTooltipMessage = () => {
        if (readOnly) {
            return t('ASSET_MARKED_AS_READ_ONLY');
        }
        if (isDisabledOrUnsupported) {
            return t('Properties that have been disabled/deleted are no longer available for edit');
        }
        return undefined;
    };

    return (
        <>
            <Tooltip title={getTooltipMessage()}>
                <Button
                    type="text"
                    className="icon-button ma-0"
                    disabled={readOnly || isDisabledOrUnsupported}
                    onClick={() => setIsEditModalVisible(true)}
                    icon={<EditIconOutlined />}
                />
            </Tooltip>
            <EditStructuredPropertyModal
                isOpen={isEditModalVisible}
                structuredProperty={structuredProperty}
                associatedUrn={associatedUrn}
                values={values}
                closeModal={() => setIsEditModalVisible(false)}
                refetch={refetch}
            />
        </>
    );
}
